export enum AnalyticsEvent {
  LOGIN = "login",
  SIGN_UP = "sign_up",
  APP_LAUNCH = "app_launch",
  SCREEN_LOAD_TIME = "screen_load_time",
  HCP_UPDATE_START = "hcp_update_start",
  HCP_UPDATE_COMPLETE = "hcp_update_complete",
  HCP_UPDATE_ERROR = "hcp_update_error",
  PUSH_NOTIFICATION_OPEN = "push_notification_open",
  FIRST_TIME_DEPOSIT = "first_time_deposit",
  SUBSEQUENT_DEPOSIT = "subsequent_deposit",
  BONUS_ACCEPTED = "bonus_accepted",
  BONUS_USED = "bonus_used",
  FORCED_UPDATE_CLICK = "forced_update_click",
}

export enum CustomDimensions {
  LABEL = "label",
  ID = "ID",
  AMOUNT = "amount",
  USER_ID = "userId",
  DEVICE_ID = "deviceId",
}

export enum SoliticsEventName {
  LOGIN = "LoginComplete",
  BET_COMPLETED = "BetCompleted",
  GAME_LAUNCHED = "GameLaunched",
}
